
import type { PurchaseOrdersViewState } from "./purchase-order-view-state";

type Props = Pick<PurchaseOrdersViewState,
  | "qualityStatus"
  | "setQualityStatus"
  | "qualityNote"
  | "setQualityNote"
  | "qualityDisposition"
  | "setQualityDisposition"> & { dialog: Extract<NonNullable<PurchaseOrdersViewState["dialog"]>, { kind: "quality"; }>; };

export function PurchaseOrderQualityFields({
  dialog,
  qualityStatus,
  setQualityStatus,
  qualityNote,
  setQualityNote,
  qualityDisposition,
  setQualityDisposition,
}: Props) {
  return (<>
    <>
      <div className="purchase-order-decision">
        <span>{dialog.order.orderNo}</span>
        <strong>{dialog.order.supplierName}</strong>
        <p>Bu karar yalnızca Kalite birimi adına kaydedilir.</p>
      </div>
      <div className="purchase-order-form">
        <label>
          Kalite sonucu
          <select
            value={qualityStatus}
            onChange={(event) => {
              const value = event.target.value;
              if (value === "ACCEPTED" || value === "CONDITIONAL" || value === "REJECTED") setQualityStatus(value);
            }}
          >
            <option value="ACCEPTED">Kabul edildi</option>
            <option value="CONDITIONAL">Koşullu kabul</option>
            <option value="REJECTED">Uygun değil</option>
          </select>
        </label>
        {qualityStatus !== "ACCEPTED" ? (
          <label className="form-field-wide">
            Kalite açıklaması
            <textarea
              rows={3}
              value={qualityNote}
              onChange={(event) => setQualityNote(event.target.value)}
              placeholder="Kararı açık ve ölçülebilir biçimde yazın"
            />
          </label>
        ) : null}
        {qualityStatus === "REJECTED" ? (
          <label className="form-field-wide">
            Sonraki işlem
            <select
              value={qualityDisposition}
              onChange={(event) => {
                const value = event.target.value;
                if (value === "REPLACE" || value === "DEDUCT_FROM_ORDER" || value === "CONDITIONAL_ACCEPTANCE" || value === "CREATE_CAPA") setQualityDisposition(value);
              }}
            >
              <option value="REPLACE">
                Tedarikçiye iade ve ikame bekle
              </option>
              <option value="DEDUCT_FROM_ORDER">
                Miktarı siparişten düş
              </option>
              <option value="CONDITIONAL_ACCEPTANCE">
                Koşullu kabul sürecine gönder
              </option>
              <option value="CREATE_CAPA">DÖF oluştur</option>
            </select>
          </label>
        ) : null}
      </div>
    </>
  </>);
}
